/**
 * Product documentation batch search (Canna / Kratom docs pages).
 * Filters .datecon rows in place so non-matches disappear.
 * Standalone — not blocked by errors in custom.js.
 */
(function () {
  'use strict';

  function norm(value) {
    return String(value || '')
      .replace(/#/g, '')
      .replace(/\s+/g, '')
      .trim()
      .toLowerCase();
  }

  function rememberOriginalDisplay(el) {
    if (!el || el.hasAttribute('data-rb-docs-orig-display')) return;
    var computedHide = false;
    try {
      computedHide = window.getComputedStyle(el).display === 'none';
    } catch (err) {}
    var inline = (el.style && el.style.display) || '';
    el.setAttribute('data-rb-docs-orig-display', inline);
    el.setAttribute('data-rb-docs-orig-hidden', inline === 'none' || computedHide ? '1' : '0');
  }

  function restoreOriginalDisplay(el) {
    if (!el) return;
    var orig = el.getAttribute('data-rb-docs-orig-display');
    if (orig === null) return;
    el.style.display = orig;
  }

  function isOriginallyHidden(el) {
    return el && el.getAttribute('data-rb-docs-orig-hidden') === '1';
  }

  function rowMatches(datecon, query) {
    if (!query) return true;
    var dcon = datecon.querySelector('.dcon');
    var hash = norm(dcon && dcon.getAttribute('data-hash'));
    var title = norm(dcon && dcon.getAttribute('data-title'));
    var body = norm(datecon.textContent);
    return (
      hash === query ||
      hash.indexOf(query) !== -1 ||
      title.indexOf(query) !== -1 ||
      body.indexOf(query) !== -1
    );
  }

  function updateSectionHeadings(root) {
    if (!root) return;
    var nodes = Array.prototype.slice.call(root.children);
    var i;
    var node;
    var j;
    var hasVisible;

    for (i = 0; i < nodes.length; i++) {
      node = nodes[i];
      if (!node.classList) continue;
      if (!node.classList.contains('ctitle2') && !node.classList.contains('stitle2')) continue;

      rememberOriginalDisplay(node);
      hasVisible = false;
      for (j = i + 1; j < nodes.length; j++) {
        var next = nodes[j];
        if (!next.classList) continue;
        if (next.classList.contains('ctitle2')) break;
        if (node.classList.contains('stitle2') && next.classList.contains('stitle2')) break;
        if (next.classList.contains('datecon') && next.style.display !== 'none') {
          hasVisible = true;
          break;
        }
      }
      node.style.display = hasVisible ? '' : 'none';
    }
  }

  function clearSearch(input, listRoot, searchcon) {
    if (input) input.value = '';
    if (!listRoot) return;

    listRoot.style.display = '';
    if (searchcon) {
      searchcon.innerHTML = '';
      searchcon.style.display = 'none';
    }

    var items = listRoot.querySelectorAll('.datecon, .ctitle2, .stitle2');
    Array.prototype.forEach.call(items, function (el) {
      restoreOriginalDisplay(el);
    });
  }

  function runSearch(input, listRoot, searchcon) {
    if (!listRoot || !input) return;
    var query = norm(input.value);

    if (!query) {
      clearSearch(input, listRoot, searchcon);
      return;
    }

    if (searchcon) {
      searchcon.innerHTML = '';
      searchcon.style.display = 'none';
    }
    listRoot.style.display = '';

    var datecons = listRoot.querySelectorAll('.datecon');
    Array.prototype.forEach.call(datecons, function (el) {
      rememberOriginalDisplay(el);
      if (isOriginallyHidden(el)) {
        el.style.display = 'none';
        return;
      }
      el.style.display = rowMatches(el, query) ? 'block' : 'none';
    });

    updateSectionHeadings(listRoot.querySelector('.main-header2') || listRoot);
  }

  function bind() {
    var input = document.getElementById('search');
    var searchBtn = document.getElementById('ssearch');
    var clearBtn = document.getElementById('sclear');
    if (!input || !searchBtn) return;

    var listRoot = document.querySelector('.mhconz');
    var searchcon = document.querySelector('.searchcon');
    if (!listRoot) return;

    // Snapshot original visibility once (includes metafield-hidden rows).
    Array.prototype.forEach.call(
      listRoot.querySelectorAll('.datecon, .ctitle2, .stitle2'),
      rememberOriginalDisplay
    );

    searchBtn.setAttribute('type', 'button');
    if (clearBtn) clearBtn.setAttribute('type', 'button');

    searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      runSearch(input, listRoot, searchcon);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        clearSearch(input, listRoot, searchcon);
      });
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        runSearch(input, listRoot, searchcon);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
